module.exports = __webpack_public_path__ + "static/media/play_button_o.ff8d7ef1.svg";